import React from 'react';
import { Button, Result } from 'antd';
import { useLocale } from '../../contexts/LocaleContext';
import styles from './StateViews.module.css';

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ title, description, onRetry }) => {
  const { locale } = useLocale();
  const defaultTitle = locale === 'fa' ? 'خطایی رخ داد' : 'Something went wrong';
  const defaultDescription =
    locale === 'fa' ? 'لطفاً دوباره تلاش کنید.' : 'Please try again.';
  const retryLabel = locale === 'fa' ? 'تلاش مجدد' : 'Retry';

  return (
    <div className={styles.container}>
      <Result
        status="error"
        title={title ?? defaultTitle}
        subTitle={description ?? defaultDescription}
        extra={
          onRetry ? (
            <Button type="primary" onClick={onRetry}>
              {retryLabel}
            </Button>
          ) : undefined
        }
      />
    </div>
  );
};

export default ErrorState;
